const maintenanceStoreKey = 'maintenance-hidden-ids';

export class Store {
    static getMaitenanceKey(): string {
        return maintenanceStoreKey;
    }

    static storeMaintenanceId(id: number): void {
        let content: Array<number> = [];

        // Retrieve content if exists
        const item = localStorage.getItem(maintenanceStoreKey);
        if (null !== item) {
            content = JSON.parse(item);
        }

        // If the key do not already exists, add it
        if (!content.includes(id)) {
            content.push(id);
        }
        // Store it into the browser
        localStorage.setItem(maintenanceStoreKey, JSON.stringify(content));
    }

    static idMaintenanceIdStored(id: number) {
        const item = localStorage.getItem(maintenanceStoreKey);

        if (null !== item) {
            const content = JSON.parse(item) as Array<number>;
            if (content.includes(id)) {
                return true;
            }
        }

        return false;
    }
}
